import { colors } from '@xpertdox_js/xdstyle';


export default {
  errorMsg: {
    color: colors.error
  },
  btn: {
    borderRadius: '10rem',
    marginRight: '.4rem',
  }
}
